"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cerignale": {
    "dd21c4ef": [{
      "hkey": "35b88d4a",
      "slug": "cerignale",
      "name": "Cerignale",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "35b88d4a",
      "slug": "cerignale",
      "name": "Cerignale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b074fe0": [{
      "hkey": "35b88d4a",
      "slug": "cerignale",
      "name": "Cerignale",
      "primary": true,
      "skipSearch": false
    }],
    "zermogliana": [{
      "hkey": "35b88d4a",
      "slug": "cerignale",
      "name": "Cerignale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;